<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main size-modal">
      <div class="title-area" id="modal-moving">
        <h2>サイズ設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <div class="error_messages">
          <div v-for="(errorMessage, idx) in errorMessageMap" :key="idx" class="error_message">
            {{ errorMessage }}
          </div>
        </div>
        <table>
          <tbody>
            <tr>
              <th class="th">幅</th>
              <td class="item_td">基準面</td>
              <td><input type="radio" :value="true" v-model="isLeft">左面基準</td>
              <td><input type="radio" :value="false" v-model="isLeft">右面基準</td>
            </tr>
            <span v-if="minWidth == null && maxWidth == null"></span>
            <tr v-else-if="minWidth == maxWidth">
              <td></td>
              <td>固定値：{{ minWidth }}mm</td>
            </tr>
            <tr v-else-if="maxWidth == null">
              <td></td>
              <td>最小値：{{ minWidth }}mm</td>
            </tr>
            <tr v-else-if="minWidth == null">
              <td></td>
              <td>最大値：{{ maxWidth }}mm</td>
            </tr>
            <tr v-else-if="minWidth != maxWidth">
              <td></td>
              <td>最小値：{{ minWidth }}mm</td>
              <td>最大値：{{ maxWidth }}mm</td>
            </tr>
            <tr v-if="moduleOptionListX && moduleOptionListX.length > 0">
              <td></td>
              <td class="item_td">モジュール</td>
              <td>
                <select class="select_td" :disabled="showModuleX" v-model.number="selectWidth">
                  <option v-for="(option,index) in moduleOptionListX" :key="index">{{ option || '' }}</option>
                </select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="item_td">指定サイズ</td>
              <td><input type="number" v-model.number="inputWidth" class="input_td" :disabled="showSpecifyX"></td>
              <td><input type="checkbox" :disabled="showOutsideX" @click="onClickOutsideX" v-model="outsideX">モジュール外</td>
            </tr>
            <tr>
              <th class="th">高さ</th>
              <td class="item_td">基準面</td>
              <td><input type="radio" :value="true" v-model="isBottom">下面基準</td>
              <td><input type="radio" :value="false" v-model="isBottom">上面基準</td>
            </tr>
            <span v-if="minHeight == null && maxHeight == null"></span>
            <tr v-else-if="minHeight == maxHeight">
              <td></td>
              <td>固定値：{{ minHeight }}mm</td>
            </tr>
            <tr v-else-if="maxHeight == null">
              <td></td>
              <td>最小値：{{ minHeight }}mm</td>
            </tr>
            <tr v-else-if="minHeight == null">
              <td></td>
              <td>最大値：{{ maxHeight }}mm</td>
            </tr>
            <tr v-else-if="minHeight != maxHeight">
              <td></td>
              <td>最小値：{{ minHeight }}mm</td>
              <td>最大値：{{ maxHeight }}mm</td>
            </tr>
            <tr v-if="moduleOptionListY && moduleOptionListY.length > 0">
              <td></td>
              <td class="item_td">モジュール</td>
              <td>
                <select class="select_td" :disabled="showModuleY" v-model.number="selectHeight">
                  <option v-for="(option,index) in moduleOptionListY" :key="index">{{ option || '' }}</option>
                </select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="item_td">指定サイズ</td>
              <td><input type="number" v-model.number="inputHeight" class="input_td" :disabled="showSpecifyY"></td>
              <td><input type="checkbox" :disabled="showOutsideY" @click="onClickOutsideY" v-model="outsideY">モジュール外</td>
            </tr>
            <tr>
              <th class="th">奥行き</th>
              <td class="item_td">指定方法</td>
              <td><input type="radio" :value="true" v-model="faceBase">キャビネット前面まで</td>
              <td><input type="radio" :value="false" v-model="faceBase">アウトセット扉前面まで</td>
            </tr>
            <tr>
              <td></td>
              <td class="item_td">基準面</td>
              <td><input type="radio" :value="true" v-model="isBack">後面基準</td>
              <td><input type="radio" :value="false" v-model="isBack">前面基準</td>
            </tr>
            <span v-if="minDepth == null && maxDepth == null"></span>
            <tr v-else-if="minDepth == maxDepth">
              <td></td>
              <td>固定値：{{ faceBase ? minDepth : minDepth + doorDepth }}mm</td>
            </tr>
            <tr v-else-if="maxDepth == null">
              <td></td>
              <td>最小値：{{ faceBase ? minDepth : minDepth + doorDepth }}mm</td>
            </tr>
            <tr v-else-if="minDepth == null">
              <td></td>
              <td>最大値：{{ faceBase ? maxDepth : maxDepth + doorDepth }}mm</td>
            </tr>
            <tr v-else-if="minDepth != maxDepth">
              <td></td>
              <td>最小値：{{ faceBase ? minDepth : minDepth + doorDepth}}mm</td>
              <td>最大値：{{ faceBase ? maxDepth : maxDepth + doorDepth }}mm</td>
            </tr>
            <tr v-if="moduleOptionListZ && moduleOptionListZ.length > 0">
              <td></td>
              <td class="item_td">モジュール</td>
              <td>
                <select class="select_td" :disabled="showModuleZ" v-model.number="selectDepth">
                  <option v-for="(option,index) in moduleOptionListZ" :key="index">{{ option || '' }}</option>
                </select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="item_td">指定サイズ</td>
              <td><input type="number" v-model.number="inputDepth" class="input_td" :disabled="showSpecifyZ"></td>
              <td><input type="checkbox" :disabled="showOutsideZ" @click="onClickOutsideZ" v-model="outsideZ">モジュール外</td>
            </tr>
          </tbody>
        </table>
        <table frame="void" id="data_table">
          <tbody>
            <tr>
              <td></td>
              <td>設定前</td>
              <td></td>
              <td>設定後</td>
            </tr>
            <tr>
              <td class="data_td">幅</td>
              <td>{{ preWidth }}</td>
              <td>→</td>
              <td>{{ !showSpecifyX ? inputWidth : selectWidth }}</td>
            </tr>
            <tr>
              <td class="data_td">高さ</td>
              <td>{{ preHeight }}</td>
              <td>→</td>
              <td>{{ !showSpecifyY ? inputHeight : selectHeight }}</td>
            </tr>
            <tr>
              <td class="data_td">奥行き</td>
              <td>{{ faceBase ? preDepth : preDepth + doorDepth }}</td>
              <td>→</td>
              <td>{{ !showSpecifyZ ? inputDepth : selectDepth }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="editSize">OK</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import {EDIT_TYPE, FACE_TYPE, VIEW_TYPE, PLANNING_TYPE} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'SetSizeModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    editChildrenDoor: null
  },
  data () {
    return {
      modalShown: false,
      /** 設定前：幅 */
      preWidth: null,
      /** 設定前：高さ */
      preHeight: null,
      /** 設定前：奥行 */
      preDepth: null,
      /** 設定後：幅 */
      inputWidth: null,
      /** 設定後：高さ */
      inputHeight: null,
      /** 設定後：奥行 */
      inputDepth: null,
      baseDepth: null,
      /** 選択：幅 */
      selectWidth: null,
      /** 選択：高さ */
      selectHeight: null,
      /** 選択：奥行 */
      selectDepth: null,
      /** 選択：幅基準面 */
      isLeft: true,
      /** 選択：高さ基準面 */
      isBottom: true,
      /** 選択：奥行き基準面 */
      isBack: true,
      /** 選択：基準ユニット面 */
      faceBase: true,
      /** 選択：扉奥行きサイズ */
      doorDepth: null,
      /** 送信：幅基準面 */
      widthRefer: FACE_TYPE.RIGHT,
      /** 送信：高さ基準面 */
      heightRefer: FACE_TYPE.TOP,
      /** 送信：奥行き基準面 */
      depthRefer: FACE_TYPE.FRONT,
      /** モジュール外：X */
      outsideX: false,
      /** モジュール外：Y */
      outsideY: false,
      /** モジュール外：Z */
      outsideZ: false,
      /** モジュール選択表示：X */
      showModuleX: true,
      /** モジュール選択表示：Y */
      showModuleY: true,
      /** モジュール選択表示：Z */
      showModuleZ: true,
      /** 指定サイズ表示：X */
      showSpecifyX: true,
      /** 指定サイズ表示：Y */
      showSpecifyY: true,
      /** 指定サイズ表示：Z */
      showSpecifyZ: true,
      /** モジュール外表示：X */
      showOutsideX: true,
      /** モジュール外表示：Y */
      showOutsideY: true,
      /** モジュール外表示：Z */
      showOutsideZ: true,
      /** 最小幅 */
      minWidth: null,
      /** 最大幅 */
      maxWidth: null,
      /** 最小高さ */
      minHeight: null,
      /** 最大高さ */
      maxHeight: null,
      /** 最小奥行 */
      minDepth: null,
      /** 最大奥行 */
      maxDepth: null,
      /** エラーメッセージ */
      errorMessageMap: {
        width: '',
        height: '',
        depth: ''
      }
    }
  },
  watch: {
    isLeft: function () {
      if (this.isLeft) {
        this.widthRefer = FACE_TYPE.RIGHT
      } else {
        this.widthRefer = FACE_TYPE.LEFT
      }
    },
    isBottom: function () {
      if (this.isBottom) {
        this.heightRefer = FACE_TYPE.TOP
      } else {
        this.heightRefer = FACE_TYPE.BOTTOM
      }
    },
    isBack: function () {
      if (this.isBack) {
        this.depthRefer = FACE_TYPE.FRONT
      } else {
        this.depthRefer = FACE_TYPE.BACK
      }
    },
    faceBase: function () {
      if (this.faceBase) {
        this.inputDepth = this.baseDepth
      } else {
        this.inputDepth = this.baseDepth + this.doorDepth
      }
    },
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    editCtrlSpaces: function () {
      this.initData()
      if (this.editCtrlSpaces && this.editCtrlSpaces.length > 0) {
        this.preWidth = this.editCtrlSpaces[0].w
        this.preHeight = this.editCtrlSpaces[0].h
        this.preDepth = this.editCtrlSpaces[0].d
        this.inputWidth = this.editCtrlSpaces[0].w
        this.inputHeight = this.editCtrlSpaces[0].h
        this.inputDepth = this.editCtrlSpaces[0].d
        this.baseDepth = this.editCtrlSpaces[0].d
        this.doorDepth = this.editChildrenDoor
        this.getMinMaxWHD()
      }
      if (!this.module) {
        this.showSpecifyX = false
        this.showSpecifyY = false
        this.showSpecifyZ = false
      }
    },
    module: function () {
      if (this.module && Object.keys(this.module).length > 0) {
        /** X：モジュールなし */
        if (this.module.attValue1 === 0) {
          this.showSpecifyX = false
        /** X：ピッチかつ許容しない */
        } else if (this.module.attValue1 === 1 && this.module.attValue2 === 0) {
          this.showModuleX = false
        /** X：ピッチかつ許容する */
        } else if (this.module.attValue1 === 1 && this.module.attValue2 === 1) {
          this.showModuleX = false
          this.showOutsideX = false
        /** X：固定かつ許容しない */
        } else if (this.module.attValue1 === 2 && this.module.attValue2 === 0) {
          this.showModuleX = false
        /** X：固定かつ許容する */
        } else if (this.module.attValue1 === 2 && this.module.attValue2 === 1) {
          this.showModuleX = false
          this.showOutsideX = false
        }
        /** Y：モジュールなし */
        if (this.module.attValue3 === 0) {
          this.showSpecifyY = false
        /** Y：ピッチかつ許容しない */
        } else if (this.module.attValue3 === 1 && this.module.attValue4 === 0) {
          this.showModuleY = false
        /** Y：ピッチかつ許容する */
        } else if (this.module.attValue3 === 1 && this.module.attValue4 === 1) {
          this.showModuleY = false
          this.showOutsideY = false
        /** Y：固定かつ許容しない */
        } else if (this.module.attValue3 === 2 && this.module.attValue4 === 0) {
          this.showModuleY = false
        /** Y：固定かつ許容する */
        } else if (this.module.attValue3 === 2 && this.module.attValue4 === 1) {
          this.showModuleY = false
          this.showOutsideY = false
        }
        /** Z：モジュールなし */
        if (this.module.attValue5 === 0) {
          this.showSpecifyZ = false
        /** Z：ピッチかつ許容しない */
        } else if (this.module.attValue5 === 1 && this.module.attValue6 === 0) {
          this.showModuleZ = false
        /** Z：ピッチかつ許容する */
        } else if (this.module.attValue5 === 1 && this.module.attValue6 === 1) {
          this.showModuleZ = false
          this.showOutsideZ = false
        /** Z：固定かつ許容しない */
        } else if (this.module.attValue5 === 2 && this.module.attValue6 === 0) {
          this.showModuleZ = false
        /** Z：固定かつ許容する */
        } else if (this.module.attValue5 === 2 && this.module.attValue6 === 1) {
          this.showModuleZ = false
          this.showOutsideZ = false
        }
      }
    },
    moduleOptionListX: function () {
      if (this.moduleOptionListX && this.moduleOptionListX.length > 0) {
        this.selectWidth = this.moduleOptionListX[0]
      }
    },
    moduleOptionListY: function () {
      if (this.moduleOptionListY && this.moduleOptionListY.length > 0) {
        this.selectHeight = this.moduleOptionListY[0]
      }
    },
    moduleOptionListZ: function () {
      if (this.moduleOptionListZ && this.moduleOptionListZ.length > 0) {
        this.selectDepth = this.moduleOptionListZ[0]
      }
    }
  },
  computed: {
    /** 幅移動量 */
    widthAmount: function () {
      // 指定サイズ入力
      if (this.preWidth !== null && this.inputWidth !== null && !this.showSpecifyX) {
        if (this.isLeft) {
          return this.inputWidth - this.preWidth
        } else {
          return this.preWidth - this.inputWidth
        }
      }
      // モジュール選択
      if (this.preWidth !== null && this.selectWidth !== null && this.showSpecifyX) {
        if (this.isLeft) {
          return this.selectWidth - this.preWidth
        } else {
          return this.preWidth - this.selectWidth
        }
      }
    },
    /** 高さ移動量 */
    heightAmount: function () {
      // 指定サイズ入力
      if (this.preHeight !== null && this.inputHeight !== null && !this.showSpecifyY) {
        if (this.isBottom) {
          return this.inputHeight - this.preHeight
        } else {
          return this.preHeight - this.inputHeight
        }
      }
      // モジュール選択
      if (this.preHeight !== null && this.selectHeight !== null && this.showSpecifyY) {
        if (this.isBottom) {
          return this.selectHeight - this.preHeight
        } else {
          return this.preHeight - this.selectHeight
        }
      }
    },
    /** 奥行き移動量 */
    depthAmount: function () {
      // 指定サイズ入力
      if (this.preDepth !== null && this.inputDepth !== null && !this.showSpecifyZ) {
        var doorDepth = this.doorDepth
        if (this.faceBase) doorDepth = 0

        if (this.isBack) {
          return (this.inputDepth - doorDepth) - this.preDepth
        } else {
          return this.preDepth - (this.inputDepth - doorDepth)
        }
      }
      // モジュール選択
      if (this.preDepth !== null && this.selectDepth !== null && this.showSpecifyZ) {
        if (this.isBack) {
          return (this.selectDepth - this.doorDepth) - this.preDepth
        } else {
          return this.preDepth - (this.selectDepth - this.doorDepth)
        }
      }
    },
    /** モジュール */
    module: function () {
      if (this.fileData && Object.keys(this.fileData).length && this.editCtrlSpaces.length > 0) {
        let attributeList = this.fileData.attributeModelList
        return attributeList.find(att => att.attKeycd === 'SP_MODULE' && att.spaceId === this.editCtrlSpaces[0].id)
      }
    },
    /** モジュール選択オプションリスト：X */
    moduleOptionListX: function () {
      if (this.module && this.module.attString1 !== null) {
        let optionX = this.module.attString1
        /** 固定 */
        if (optionX.indexOf('|') !== -1) {
          return optionX.split('|')
        } else {
          let n = 1
          let list = []
          let width = 0
          while (width < this.editCtrlSpaces[0].maxW) {
            width = this.editCtrlSpaces[0].minW + (parseInt(optionX) * n)
            list.push(width)
            n++
          }
          return list
        }
      }
    },
    /** モジュール選択オプションリスト：Y */
    moduleOptionListY: function () {
      if (this.module && this.module.attString2 !== null) {
        let optionY = this.module.attString2
        /** 固定 */
        if (optionY.indexOf('|') !== -1) {
          return optionY.split('|')
        } else {
          let n = 1
          let height = 0
          let list = []
          while (height < this.editCtrlSpaces[0].maxH) {
            height = this.editCtrlSpaces[0].minH + (parseInt(optionY) * n)

            list.push(height)
            n++
          }
          return list
        }
      }
    },
    /** モジュール選択オプションリスト：Z */
    moduleOptionListZ: function () {
      if (this.module && this.module.attString3 !== null) {
        let optionZ = this.module.attString3
        /** 固定 */
        if (optionZ.indexOf('|') !== -1) {
          return optionZ.split('|')
        } else {
          let n = 1
          let depth = 0
          let list = []
          while (depth < this.editCtrlSpaces[0].maxD) {
            depth = this.editCtrlSpaces[0].minD + (parseInt(optionZ) * n)
            list.push(depth)
            n++
          }
          return list
        }
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.isLeft = true
      this.isBottom = true
      this.isBack = true
      this.modalShown = true
      this.faceBase = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearErrorMessages()
      this.modalShown = false
      this.inputWidth = this.editCtrlSpaces[0].w
      this.inputHeight = this.editCtrlSpaces[0].h
      this.inputDepth = this.editCtrlSpaces[0].d
      this.baseDepth = this.editCtrlSpaces[0].d
    },
    /** 送信 */
    editSize: function () {
      this.clearErrorMessages()
      this.validationInput()
      if (this.errorMessageMap.width.length > 0 || this.errorMessageMap.height.length > 0 || this.errorMessageMap.depth.length > 0) return

      let payload = {
        spaceJoincd: this.fileData.spaceJoincd,
        spaceIds: this.editCtrlSpaces.map(space => space.id),
        editType: EDIT_TYPE.RESIZE,
        viewType: VIEW_TYPE.FRONT.code
      }
      payload.resizeInfo = [
        {faceType: this.widthRefer, amount: this.widthAmount},
        {faceType: this.heightRefer, amount: this.heightAmount},
        {faceType: this.depthRefer, amount: this.depthAmount}
      ]
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/resize', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        if (response.data.errorMessage) {
          // エラーメッセージ表示
          this.$emit('handleErrorMessage', response)
        } else {
          this.modalShown = false
          AppUtil.showModal({
            messages: ['サイズ変更しました。']
          })
          this.$emit('setResponseData', response)
        }
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error)
      })
    },
    /** 最小・最大値の取得 */
    getMinMaxWHD: function () {
      let editCtrlSpace = this.editCtrlSpaces[0]
      switch (editCtrlSpace.planningType) {
        case PLANNING_TYPE.UNIT_SKELTON:
        case PLANNING_TYPE.COMBINE:
        case PLANNING_TYPE.SETPLAN:
          // 幅
          this.minWidth = editCtrlSpace.limitMinW != null
            ? editCtrlSpace.limitMinW
            : editCtrlSpace.minW != null
              ? editCtrlSpace.minW
              : editCtrlSpace.childrenSpaceModel[0].minW
          this.maxWidth = editCtrlSpace.limitMaxW != null
            ? editCtrlSpace.limitMaxW
            : editCtrlSpace.maxW != null
              ? editCtrlSpace.maxW
              : editCtrlSpace.childrenSpaceModel[0].maxW
          // 高さ
          this.minHeight = editCtrlSpace.limitMinH != null
            ? editCtrlSpace.limitMinH
            : editCtrlSpace.minH != null
              ? editCtrlSpace.minH
              : editCtrlSpace.childrenSpaceModel[0].minH
          this.maxHeight = editCtrlSpace.limitMaxH != null
            ? editCtrlSpace.limitMaxH
            : editCtrlSpace.maxH != null
              ? editCtrlSpace.maxH
              : editCtrlSpace.childrenSpaceModel[0].maxH
          // 奥行き
          this.minDepth = editCtrlSpace.limitMinD != null
            ? editCtrlSpace.limitMinD
            : editCtrlSpace.minD != null
              ? editCtrlSpace.minD
              : editCtrlSpace.childrenSpaceModel[0].minD
          this.maxDepth = editCtrlSpace.limitMaxD != null
            ? editCtrlSpace.limitMaxD
            : editCtrlSpace.maxD != null
              ? editCtrlSpace.maxD
              : editCtrlSpace.childrenSpaceModel[0].maxD
          break
        case PLANNING_TYPE.UNIT_SURFACE:
          // 幅
          this.minWidth = editCtrlSpace.minW != null
            ? editCtrlSpace.minW
            : editCtrlSpace.childrenSpaceModel[0].minW
          this.maxWidth = editCtrlSpace.maxW != null
            ? editCtrlSpace.maxW
            : editCtrlSpace.childrenSpaceModel[0].maxW
          // 高さ
          this.minHeight = editCtrlSpace.minH != null
            ? editCtrlSpace.minH
            : editCtrlSpace.childrenSpaceModel[0].minH
          this.maxHeight = editCtrlSpace.maxH != null
            ? editCtrlSpace.maxH
            : editCtrlSpace.childrenSpaceModel[0].maxH
          // 奥行き
          this.minDepth = editCtrlSpace.minD != null
            ? editCtrlSpace.minD
            : editCtrlSpace.childrenSpaceModel[0].minD
          this.maxDepth = editCtrlSpace.maxD != null
            ? editCtrlSpace.maxD
            : editCtrlSpace.childrenSpaceModel[0].maxD
          break
        default:
          break
      }
    },
    /** 入力値のバリデーションチェック */
    validationInput: function () {
      // 値のチェック(変更された項目のみ)
      if (this.inputWidth === '') {
        this.errorMessageMap.width = '幅を入力してください。'
      } else if (this.preWidth !== this.inputWidth) {
        if (this.maxWidth != null && this.inputWidth > this.maxWidth) {
          this.errorMessageMap.width = '幅は' + this.maxWidth + '以下でご設定ください。'
        } else if (this.minWidth != null && this.inputWidth < this.minWidth) {
          this.errorMessageMap.width = '幅は' + this.minWidth + '以上でご設定ください。'
        }
      }
      if (this.inputHeight === '') {
        this.errorMessageMap.height = '高さを入力してください。'
      } else if (this.preHeight !== this.inputHeight) {
        if (this.maxHeight != null && this.inputHeight > this.maxHeight) {
          this.errorMessageMap.height = '高さは' + this.maxHeight + '以下でご設定ください。'
        } else if (this.minHeight != null && this.inputHeight < this.minHeight) {
          this.errorMessageMap.height = '高さは' + this.minHeight + '以上でご設定ください。'
        }
      }
      if (this.inputDepth === '') {
        this.errorMessageMap.depth = '奥行きを入力してください。'
      } else if (this.preDepth !== this.inputDepth) {
        if (this.maxDepth != null && this.inputDepth > this.maxDepth) {
          this.errorMessageMap.depth = '奥行きは' + this.maxDepth + '以下でご設定ください。'
        } else if (this.minDepth != null && this.inputDepth < this.minDepth) {
          this.errorMessageMap.depth = '奥行きは' + this.minDepth + '以上でご設定ください。'
        }
      }
    },
    /** エラーメッセージのクリア */
    clearErrorMessages: function () {
      this.errorMessageMap.width = ''
      this.errorMessageMap.height = ''
      this.errorMessageMap.depth = ''
    },
    /** モジュール外選択：X */
    onClickOutsideX: function () {
      if (!this.outsideX) {
        this.showModuleX = true
        this.showSpecifyX = false
      } else {
        this.showModuleX = false
        this.showSpecifyX = true
      }
    },
    /** モジュール外選択：Y */
    onClickOutsideY: function () {
      if (!this.outsideY) {
        this.showModuleY = true
        this.showSpecifyY = false
      } else {
        this.showModuleY = false
        this.showSpecifyY = true
      }
    },
    /** モジュール外選択：Z */
    onClickOutsideZ: function () {
      if (!this.outsideZ) {
        this.showModuleZ = true
        this.showSpecifyZ = false
      } else {
        this.showModuleZ = false
        this.showSpecifyZ = true
      }
    },
    /** データ初期化 */
    initData: function () {
      this.showModuleX = true
      this.showModuleY = true
      this.showModuleZ = true
      this.showSpecifyX = true
      this.showSpecifyY = true
      this.showSpecifyZ = true
      this.showOutsideX = true
      this.showOutsideY = true
      this.showOutsideZ = true
      this.outsideX = false
      this.outsideY = false
      this.outsideZ = false
      this.selectWidth = null
      this.selectHeight = null
      this.selectDepth = null
    }
  }
}
</script>
<style lang="scss" scoped>
.size-modal{
  max-height: 100%;
  max-width: 650px;
}
.data-area{
  min-height: 300px;
  margin: 20px auto;
  table td{
    border:none !important;
  }
  .th{
    width: 55%;
    line-height: 30px;
    text-align: center;
    border:none;
    background:none;
  }
  .input_td{
    width: 80%
  }
  .select_td{
    width: 100%
  }
  .item_td{
    width: 60%
  }
  #data_table{
    text-align: center;
    width: 70%;
    margin: 20px auto;
    td{
      width: 10%;
    }
    .data_td{
      width: 1%;
    }
  }
}
.error_messages{
  margin-left: auto;
  margin-right: auto;
  max-width: 270px;
  min-width: 270px;
}
.error_message {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetSizeModal.vue